export default {
      id: "close-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#close",
      toString: function () {
        return this.url;
      }
    }